import { media } from 'styled-bootstrap-grid'
import { css } from 'styled-components'

export const navControlStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 2px;
  flex: 1 0;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;

  &:last-child {
    margin-right: 0;
  }

  ${({ theme }) => `
    height: calc(${theme.space.mobile.base} * 2);
    padding: 0 ${theme.space.mobile.large};
    color: ${theme.color.black};
    background-color: ${theme.color.haze};
    ${theme.pattern};
  `}

  ${({ theme }) => media.sm`
    flex: auto 0;
    height: calc(${theme.space.desktop.base} + ${theme.space.desktop.small});
    padding: 0 ${theme.space.desktop.large};
  `}
`

export const activeNavControlStyles = css`
  ${({ theme }) => `
    background-color: ${theme.color.gold};
    background-image: none;
    cursor: default;
  `}
`
